export type UTM = Partial<Nullable<{ source: string; medium: string; campaign: string }>>

export const getUTMComments = (model?: UTM | null) => {
  const description = model
    ? Object.entries(model)
        .map((e) => (e[1] ? `${e[0]}: ${e[1]}` : undefined))
        .filter(Boolean)
        .join(', ')
        .trim()
    : undefined
  if (description) return `UTM: [${description}]`
}

export const UTM = {
  getUTMComments,
}
